import React, { lazy } from 'react';
export const About: React.FC = () => {
  return <section id="about" className="min-h-[80vh] bg-[#fdf8ec] flex flex-col lg:flex-row items-center justify-center px-4 sm:px-6 lg:px-8 xl:px-12 py-16 sm:py-20 lg:py-24 gap-10 lg:gap-20" data-id="element-31">
      {/* Text Content */}
      <div className="w-full lg:w-1/2 lg:max-w-xl order-2 lg:order-1" data-id="element-32">
        <div className="bg-white p-8 sm:p-10 lg:p-12" data-id="element-33">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-serif text-[#486878] mb-6 sm:mb-8" data-id="element-34">
            About
          </h2>
          <div className="text-[#486878] text-lg sm:text-xl space-y-5 leading-relaxed" data-id="element-35">
            <p data-id="element-36">
              Hi, I'm Annie, a wedding planner who believes every celebration
              should feel personal and full of heart.
            </p>
            <p data-id="element-37">
              With over six years of experience in management consulting and
              operations in the tech industry, I approach every event with
              structure, creativity, and attention to detail. I love helping
              couples bring their story to life through thoughtful details and a
              seamless, stress-free planning experience.
            </p>
            <p data-id="element-38">
              Based in the San Francisco Bay Area, I work with couples locally
              and beyond to bring their vision to life with intention and care.
            </p>
          </div>
        </div>
      </div>

      {/* Image */}
      <div className="w-full lg:w-1/2 lg:max-w-xl order-1 lg:order-2 flex items-center justify-center" data-id="element-39">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/51QLXn9KGqZmB2E3DdfP9y/annie_portrait.jpg" alt="Annie - Moonstone Events" className="w-full h-auto object-contain" loading="lazy" decoding="async" data-id="element-40" />
      </div>
    </section>;
};